module.exports = __webpack_public_path__ + "img/2_54.222e0c42.png";